"use client";

import { useEffect, useState } from "react";
import { usePathname, useRouter } from "next/navigation";

// Halaman yang boleh diakses tanpa login
const PUBLIC_PATHS = ["/", "/pages/login", "/pages/reset-request", "/pages/reset-password"];

const getToken = () => {
  if (typeof window === "undefined") return null;
  return localStorage.getItem("token"); // SESUAIKAN key dengan axiosInstance-mu
};

export default function AuthGuard({
  children,
}: {
  children: React.ReactNode;
}) {
  const router = useRouter();
  const pathname = usePathname();
  const [status, setStatus] = useState<"checking" | "allowed">("checking");

  useEffect(() => {
    setStatus("checking");

    const token = getToken();
    const isPublic = PUBLIC_PATHS.some(
      (p) => pathname === p || pathname.startsWith(p + "/"),
    );

    // Belum login & mencoba akses halaman privat → tendang ke login
    if (!token && !isPublic) {
      router.replace("/");
      return;
    }
    // Sudah login tapi buka halaman login → arahkan ke dashboard
    if (token && pathname === "/") {
      router.replace("/pages/menu-utama/dashboard");
      return;
    }

    setStatus("allowed");
  }, [pathname, router]);

  if (status === "checking") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#020617] text-slate-400">
        Memuat…
      </div>
    );
  }

  return <>{children}</>;
}